import { ColorTypes, ComponentAdapter, utils } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { ObjectShare } from "@reporting/rp-types/core";
import { ToolbarItemOptions } from "../types";

export type SyncType = 1|2|3;

export enum SyncTypes {
	SYNC = 1,
	SHARE = 2,
	BOTH = 3
}

export type ListItemField = 'company'|'name_share'|'date_created'|'who_created';
/**
 * A column of the grid view (`SyncGridEditorAdapter`); the list shows the object name as the title of
 * every item. `type` tells synchronization from sharing apart where a module registers both.
 */
export type SyncColumn = 'name'|'type'|ListItemField;

export type SyncEditorOptions = {
	/** the module synchronizes chosen registrations (`synchronize(ids)`): the list offers checkboxes, the grid the selected rows */
	selectableItems?: boolean;
	syncType?: SyncType;
	/** the fields under the object name in the list view (`SyncEditor`) */
	listItemFields?: ListItemField[];
	/** the columns of the grid view (`SyncGridEditorAdapter`), in order */
	columns?: SyncColumn[];
	toolbar?: {
		refresh?: ToolbarItemOptions,
		new?: ToolbarItemOptions,
		sync?: ToolbarItemOptions,
	},
};

export const DEFAULT_SYNC_EDITOR_OPTIONS: SyncEditorOptions = {
	syncType: SyncTypes.SYNC,
	selectableItems: false,
	listItemFields: ['company', 'name_share', 'date_created', 'who_created'],
	columns: ['name', 'company', 'name_share', 'date_created', 'who_created'],
	toolbar: {
		refresh: {
			text: null,
			color: ColorTypes.Gray,
			icon: 'arrows-rotate',
			enabled: true
		},
		new: {
			text: msg('Add'),
			color: ColorTypes.Blue,
			icon: 'plus',
			enabled: true
		},
		sync: {
			text: msg('Synchronize'),
			color: ColorTypes.Green,
			icon: 'arrows-spin',
			enabled: true
		}
	}
};

export abstract class SyncEditorAdapter extends ComponentAdapter {

	getOptions(): null|Partial<SyncEditorOptions>|Promise<Partial<SyncEditorOptions>> {
		return Object.assign({}, DEFAULT_SYNC_EDITOR_OPTIONS);
	}

	createOptions(options: Partial<SyncEditorOptions>): SyncEditorOptions {
		options = utils.mergeDeep({}, DEFAULT_SYNC_EDITOR_OPTIONS, options);
		return options;
	}

	synchronize(ids?: number[]|null): void|Promise<void> { return; }

	getEditFormComponent(idz: number = null): HTMLElement|Promise<HTMLElement> { return null; }

	abstract delete(idz: number): void|Promise<void>;

	abstract getObjects(): ObjectShare[]|Promise<ObjectShare[]>;

}
